export default __webpack_public_path__ + "static/Icon-Art_of_Science@2x-683fa9dedcec1b8b7a8d946d4fbb5b90.png";